import styled from 'styled-components';

export const StyledUploadedFiles = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
  height: fit-content;
  border: 1px var(--p-color-input-border) dashed;

  .thumbnail {
    height: 56px;
    width: 66px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--p-color-bg);
    border-radius: 5px 0 0 5px;
    margin: -1px;
  }

  .content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 15px;
  }
`;
